module.exports = __webpack_public_path__ + "static/media/294508.c2fbaa0f.png";